"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
require("./index.css");
require("@/app/shared/i18n/calendarLocales");
const App_1 = __importDefault(require("@/app/App"));
const reportWebVitals_1 = __importDefault(require("@/app/reportWebVitals"));
const constants_1 = require("@/app/shared/constants");
const key_1 = require("@/app/shared/helpers/storage/constants/key");
const analyticsService_1 = require("@/app/shared/services/analyticsService");
const client_1 = __importDefault(require("react-dom/client"));
analyticsService_1.analyticsService.init();
/** Auth-related localStorage keys synced from the extension wrapper. */
const AUTH_STORAGE_KEYS = new Set([
    key_1.StorageKey.SERVER_TYPE,
    key_1.StorageKey.SERVER_ENVIRONMENT,
    key_1.StorageKey.SERVER_SALESFORCE_INSTANCE_URL,
    key_1.StorageKey.SERVER_SALESFORCE_ACCESS_TOKEN,
    key_1.StorageKey.SERVER_SALESFORCE_ACCESS_TOKEN_EXPIRATION,
    key_1.StorageKey.SERVER_SALESFORCE_REFRESH_TOKEN,
    key_1.StorageKey.SERVER_SALESFORCE_REFRESH_TOKEN_EXPIRATION,
    key_1.StorageKey.SERVER_PREFIX,
]);
/** Restore auth data from a key-value record into localStorage. */
function restoreAuthData(storage) {
    for (const [key, value] of Object.entries(storage)) {
        if (key.startsWith('CognitoIdentityServiceProvider') || AUTH_STORAGE_KEYS.has(key)) {
            if (value && value !== 'undefined') {
                localStorage.setItem(key, value);
            }
        }
    }
}
function restoreAuthDataFromUrl() {
    const params = new URLSearchParams(window.location.search);
    restoreAuthData(Object.fromEntries(params.entries()));
}
const params = new URLSearchParams(window.location.search);
const extensionIntegration = params.get('extensionIntegration');
const isInIframe = window.parent !== window;
const AUTH_HANDSHAKE_TIMEOUT_MS = 3000;
let appRendered = false;
function renderApp() {
    if (appRendered)
        return;
    appRendered = true;
    const root = client_1.default.createRoot(document.getElementById('root'));
    root.render((0, jsx_runtime_1.jsx)(App_1.default, {}));
    (0, reportWebVitals_1.default)();
}
if (extensionIntegration === constants_1.ExtensionIntegration.BROWSER && isInIframe) {
    window.addEventListener('message', function handler(event) {
        if (event.data?.type === constants_1.RegularMessage.INIT_AUTH_STORAGE) {
            if (event.data.payload?.storage) {
                restoreAuthData(event.data.payload.storage);
            }
            if (event.data.payload?.subject !== undefined) {
                localStorage.setItem(key_1.StorageKey.SUBJECT, event.data.payload.subject);
            }
            if (event.data.payload?.recipientsEmails !== undefined) {
                localStorage.setItem(key_1.StorageKey.RECIPIENTS_EMAILS, JSON.stringify(event.data.payload.recipientsEmails));
            }
            if (event.data.payload?.composeViewId !== undefined) {
                localStorage.setItem(key_1.StorageKey.COMPOSE_VIEW_ID, event.data.payload.composeViewId);
            }
            if (event.data.payload?.integration !== undefined) {
                localStorage.setItem(key_1.StorageKey.INTEGRATION, event.data.payload.integration);
            }
            window.removeEventListener('message', handler);
            renderApp();
        }
    });
    window.parent.postMessage({ type: constants_1.RegularMessage.IFRAME_AUTH_READY }, '*');
    setTimeout(renderApp, AUTH_HANDSHAKE_TIMEOUT_MS);
}
else if (extensionIntegration === constants_1.ExtensionIntegration.OUTLOOK && window.Office?.onReady) {
    window.Office.onReady(() => {
        restoreAuthDataFromUrl();
        renderApp();
    });
}
else {
    restoreAuthDataFromUrl();
    renderApp();
}
